// Abbreviates large numbers (1.2K, 3.4M) for compact display.
// Pair with the full value (e.g. via a tooltip) so precision isn't lost.
export const formatCompactNumber = (value) => {
  const num = Number(value) || 0;
  const abs = Math.abs(num);

  if (abs >= 1000000) {
    return `${(num / 1000000).toFixed(1).replace(/\.0$/, "")}M`;
  }
  if (abs >= 1000) {
    return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  }
  return num.toLocaleString(undefined, { maximumFractionDigits: 2 });
};

export const formatFullNumber = (value) =>
  (Number(value) || 0).toLocaleString(undefined, {
    maximumFractionDigits: 2,
  });
